module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-48.e04965f2.png";